import { Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { ColorByAttribute } from "./ColorByAttribute";
import { ColorByScore } from "./ColorByScore";
import { ColorByTreatment } from "./ColorByTreatment";
import { useMemo } from "react";
import { AttributeDefinitions } from "@keita/lanepatrol-sdk";
import { ColorBy, ColorByType } from "../../../../map/models/ColorBy";
import { tScoreType } from "../../../../coding/utils/score-utils";
import { AttributeUtils } from "../../../../coding/utils/attribute-utils";

interface Props {
  colorBy: ColorBy;
}

const ColorByLegendBase: React.FC<Props> = ({ colorBy }) => {
  const [text, content] = useMemo(() => {
    switch (colorBy.type) {
      case ColorByType.Score:
        return [tScoreType(colorBy.scoreKey), <ColorByScore />];
      case ColorByType.Treatment:
        return [
          t(`sdk:treatments.${colorBy.treatmentType}`),
          <ColorByTreatment />,
        ];
      case ColorByType.Attribute:
        const attribute = AttributeDefinitions.getByName(
          colorBy.attributeName
        )!;
        return [
          AttributeUtils.getLabel(colorBy.attributeName),
          <ColorByAttribute attribute={attribute} />,
        ];
    }
  }, [colorBy]);

  return (
    <>
      <Text fontSize="sm" fontWeight="semibold">
        {text}
      </Text>
      {content}
    </>
  );
};

export const ColorByLegend = observer(ColorByLegendBase);
